<div style="position: relative" [id]="ContainerId">
  <div class="filter-container" [ngClass]="{'filter-container-open': FilterOpen}" [style.height]="Height"
    (click)="openFilter()">
    <div class="placeholder-container" *ngIf="!SelectedOptions || SelectedOptions.length == 0">
      <img *ngIf="IconUrl" [src]="IconUrl" alt="">
      <p>{{PlaceholderFilter}}</p>
    </div>
    <div class="selected-text-container" *ngIf="SelectedOptions?.length && SelectedOptions.length > 0">
      <p *ngIf="Multiselect">{{SelectedOptions.length}} {{SelectedText}}</p>
      <p *ngIf="!Multiselect">{{SelectedOptions[0][BindName]}}</p>
      <img (click)="deleteFilter($event)" class="close-icon" src="../../../assets/icons/x.svg" alt="">
    </div>
    <img class="chevron-icon" [ngClass]="{'transform-rotation-180': FilterOpen}" src="/assets/icons/chevron-down.svg"
      alt="">
  </div>


  <div class="absolut-container" [style.zIndex]="zIndex" [style.width]="PopupWidth ? PopupWidth : '300px'"
    *ngIf="FilterOpen">
    <div class="no-option-container" *ngIf="!Options || Options.length == 0">
      {{NoOptionsText}}
    </div>
    <div *ngIf="Options && Options.length > 0">
      <div class="options-list-container">
        <div *ngFor="let option of Options; let i = index; let last = last">
          <div class="split" *ngIf="i != 0"></div>
          <div class="option-container" (click)="updateSelectedOption(option, $event)">
            {{option[this.BindName]}}<input type="radio" class="checkbox-square"
              [checked]="SelectedOptionsIds.includes(option[BindId])" readonly>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>